import React from 'react'

 const YearsSelector = ({numberOfYears, setNumberOfYears}) => {
    const numbers = Array.from({ length: 30 }, (_, i) => i + 1);
    return (
        <div className='inline-block'>
            <select
            value={numberOfYears || 1} 
            onChange={(e) => setNumberOfYears(e.target.value)} // no need for extra arrow here
            className="border border-purple-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500
                    bg-white text-black dark:bg-gray-800 w-[60px] dark:text-white dark:border-gray-600 dark:focus:ring-purple-400"
        >
            <option className='h-[60px]' value="" disabled>--</option>
            {numbers.map((num) => (
                <option className='h-[60px]' key={num} value={num}>
                    {num}    
                </option>
                
            ))}
        </select>
         <span className="text-lg text-gray-100 mt-1">{numberOfYears===1?'year':'years'}</span>
        </div>
    );
}


export default YearsSelector